export const uk = {
    'audip-genres-title': 'Жанры'
};
